import { PropsWithChildren } from 'react';

import { Portal as MuiPortal } from '@mui/material';

import { Portal } from './types';

import { Box } from '@cast/design-system';
import type { BoxProps } from '@cast/design-system';

const getPortalId = (portal: `${Portal}`) =>
  `portal-slot-${portal.toLowerCase()}`;

type ToPortalProps = PropsWithChildren<{
  portal: `${Portal}`;
}>;

export const ToPortal = ({ portal, children }: ToPortalProps) => {
  return (
    <MuiPortal container={document.getElementById(getPortalId(portal))}>
      {children}
    </MuiPortal>
  );
};

type PortalSlotProps = { portal: `${Portal}` } & BoxProps;

export const PortalSlot = ({ portal, ...boxProps }: PortalSlotProps) => {
  return <Box id={getPortalId(portal)} position="relative" {...boxProps} />;
};
